module.exports = __webpack_public_path__ + "media/images/flags/32/British-Antarctic-Territory-df4296db44d761d56d9f1b5775426317.png";